import "./index.css";


function Footer(){

	return(
		<footer className='footmat'>
			<div className='addition'>
				<ul className='string'>
					<h3 className='rock'> Site Map </h3>

					<a href="/blog/" > Blog </a>
					<a href="/service/" > Freelance Service </a>
					<a href="/" > Home Page </a>
					<a href="/about/" > About Me </a>

				</ul>


				<ul className='string'>
					<h3 className='rock'>Follow Me (Reach out)</h3>
					
					<a href="https://www.twitter.com/theibrahim_o/" target="_blank" rel="noreferrer"> Twitter </a>
					<a href="https://www.linkedin.com/in/ibrahim-oduola/" target="_blank" rel="noreferrer"> LinkedIn </a>
					<a href="https://www.facebook.com/oduola.ibrahim.7/" target="_blank" rel="noreferrer"> Facebook </a>
					<a href="https://www.github.com/theibrahim7" target="_blank" rel="noreferrer"> Github </a>
					<a href="https://www.stackoverflow.com/users/10984641/ibrahim" target="_blank" rel="noreferrer"> Stack Overflow </a>
				</ul>
			
			</div>

			<div className='feet'>
				<p> Copyright &copy; 2022: All Rights Reserved </p>

			</div>


		</footer>
		)
};

export default Footer;